import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.window.CanvasBasedWindow
import androidx.compose.ui.window.ComposeViewport
import androidx.compose.ui.window.ComposeViewportConfiguration
import androidx.lifecycle.Lifecycle
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLMetaElement
import org.w3c.dom.HTMLTextAreaElement
import org.w3c.dom.events.Event
import team.platforma.aicombo.App
import team.platforma.aicombo.di.AppDI
import team.platforma.aicombo.telegram.checkData
import team.platforma.aicombo.telegram.onTelegramDataReceived
import team.platforma.aicombo.telegram.saveRedirectTelegramDataToLocalStorage


@OptIn(ExperimentalComposeUiApi::class, DelicateCoroutinesApi::class)
fun main() {
    saveRedirectTelegramDataToLocalStorage()
    onWasmReady {
        registerServiceWorker()
        CoroutineScope(Dispatchers.Main).launch {
            try {
                AppDI().initKoinWeb()
                ComposeViewport(
                    configure = {

                    },
                    content = {
                    Box(
                        modifier = Modifier.fillMaxSize()
                    ) {
                        console.log("TG Data:$ { checkData() }")
                        App()
                    }

                })
            } catch (t: Throwable) {
                println(
                    t.printStackTrace()
                )
            }

        }
//        createOverlayInput(
//            placeholder = "Введите текст...",
//            onChange = { value ->
//                console.log("Ввод с клавиатуры: $value")
//            }
//        )

    }
}


fun registerServiceWorker() {
    if (js("navigator.serviceWorker") != undefined) {
        js("navigator.serviceWorker.register('/sw.js')")
    }
}

private var deferredPrompt: dynamic = null
fun setupBeforeInstallPromptListener(onPromptReady: () -> Unit) {
    window.addEventListener("beforeinstallprompt", { event ->
        console.log("📦 beforeinstallprompt fired")
        event.asDynamic().preventDefault() // отменяем автоматический показ диалога
        deferredPrompt = event
        onPromptReady()
    })
}

fun showInstallPrompt() {
    deferredPrompt?.let { promptEvent ->
        promptEvent.prompt()
        promptEvent.userChoice.then { choiceResult ->
            if (choiceResult.outcome == "accepted") {
                console.log("User accepted the install prompt")
            } else {
                console.log("User dismissed the install prompt")
            }
            clearPrompt()
        }
    }
}

fun clearPrompt() {
    deferredPrompt = null
}


fun createOverlayInput(
    id: String = "overlay-input",
    placeholder: String = "",
    onChange: (String) -> Unit
): HTMLTextAreaElement {
    val existing = document.getElementById(id)
    if (existing != null) return existing as HTMLTextAreaElement

    val input = document.createElement("textArea") as HTMLTextAreaElement
    input.id = id

    // 📐 Стили: абсолютная позиция поверх Canvas
    input.style.position = "fixed"
    input.style.top = "0px"         // <- можешь позиционировать как хочешь
    input.style.left = "0px"
    input.style.zIndex = "9999"
    input.style.fontSize = "50px"
    input.style.padding = "8px"
    input.style.border = "3px solid #ccc"
    input.placeholder = placeholder


    input.autocomplete = "off"
    input.spellcheck = false

    // 📡 Слушаем изменение текста
    input.addEventListener("input", {
        onChange(input.value)
    })

    document.body?.appendChild(input)

    return input
}